// extracted by mini-css-extract-plugin
export default {"tab__container":"styles_tab__container__Xa-11","tab__item":"styles_tab__item__PYWKf","tab__text":"styles_tab__text__NKJLq","tab__item--actived":"styles_tab__item--actived__-z0Fy"};